import { CampaignDraft, EmailCampaign } from './types';

export const EMPTY_DRAFT: CampaignDraft = {
    id: null,
    name: '',
    locationIds: [],
    recipientType: 'all_clients',
    tags: [],
    selectedCustomerIds: 'all',
    excludedCustomerIds: [],
    templateId: null,
    subject: '',
    previewText: ''
};

// Reopens a saved draft in the wizard, with its recipient picks.
export const draftFromCampaign = (campaign: EmailCampaign): CampaignDraft => ({
    id: campaign.id,
    name: campaign.name,
    locationIds: campaign.locationIds,
    recipientType: campaign.recipientType,
    tags: campaign.tags,
    selectedCustomerIds: campaign.selectedCustomerIds,
    excludedCustomerIds: campaign.excludedCustomerIds,
    templateId: campaign.templateId,
    subject: campaign.subject,
    previewText: campaign.previewText
});
